<div *ngIf="data" class="specimen-preview-container">
    <div class="inner-container">
        <h1 class="kit-title" *ngIf="data.cases==null">Kit {{data.kitNumber}} Online Images</h1>
        <h1 class="kit-title" *ngIf="data.specimens==null">Kit {{data.kitNumber}} Online Interpretive Menu/Images</h1>
        <!-- Remove below div if you don't required warning-->

        <div class="warning-box" *ngFor="let list of data.fileList">
            <ng-container *ngIf="list.isHTML == true">
                <iframe [src]="getSenitizeURL(list.url)" target="_self" title="Content Display Block"></iframe>
            </ng-container>
            <ng-container *ngIf="list.isZip == true">
                <p><a [href]="getSenitizeURL(list.url)" (click)="onClickUrl(list.url)">{{list.name}}</a></p>
            </ng-container>
            <ng-container *ngIf="!list.isHTML && !list.isZip">
                <p><a>{{list.name}}</a></p>
            </ng-container>
        </div>
    </div>
    <div *ngIf="data.specimens && data.specimens.length > 0">
        <div *ngFor="let list of data.specimens" class="specimen-container">
            <div class="inner-container">
                <h2 class="specimen-title">{{list.specimenId}}</h2>
                <div class="specimen-image-container">
                    <ng-container *ngFor="let image of list.images">
                        <div class="specimen-image">
                            <div class="image-overlay" (click)="openImageLightbox(image.imageId)">
                                <div class="specimen-image-overlay"></div>
                                <img alt="thumbnail" *ngIf="image.thumbnailFlag !== 'N'" src="{{image.thumbnailPreSignedUrl}} "
                                    class="image">
                                <img alt="thumbnail" *ngIf="image.thumbnailFlag == 'N'" src="../../../../assets/img/no-image.jpg"
                                    class="image">
                            </div>
                            <p (click)="openImageLightbox(image.imageId)" class="specimen-image-label">
                                {{ ((image.imageLabel) ? image.imageLabel : "Image") }}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="data.cases && data.cases.length > 0">
        <div *ngFor="let list of data.cases" class="specimen-container">
            <div class="inner-container">
                <h2 class="specimen-title">{{list.catalogName}}</h2>
                <div class="case-detail"><span class="bold case-detail">Specimen:</span> {{list.anatomicSite}}</div>
                <div class="case-detail"><span class="bold">Clinical History: </span> {{list.clinicalHistory}}</div>
                <div class="case-detail"><span class="bold">Slide Type: </span> {{list.slideType}}</div>

                <div class="image-section">
                    <h2 class="image-section-title">Images</h2>
                    <div *ngIf="list.images.length == 0">There are no supplemental images for this case</div>
                    <ng-container *ngIf="list.images.length > 0">
                        <div class="specimen-image-container case-column-view">
                            <div class="row">
                                <div class="col-md-3" *ngFor="let i of columnArray">
                                    <div *ngFor="let image of list.images; let index = index">
                                        <div *ngIf="index <= 2 && i == 1">
                                            <div *ngIf="image.thumbnailFlag == 'N'" class="spacimen-label" (click)="openImageLightbox(image.imageId)">
                                                <span class="type-decs" [innerHTML]=displayImageLabelType(image)></span>
                                            </div>
                                        </div>
                                        <div *ngIf="(index >= 3 && index <= 5) && i == 2">
                                            <div *ngIf="image.thumbnailFlag == 'N'" class="spacimen-label" (click)="openImageLightbox(image.imageId)">
                                                <span class="type-decs" [innerHTML]=displayImageLabelType(image)></span>
                                            </div>
                                        </div>
                                        <div *ngIf="(index >= 6 && index <= 8) && i == 3">
                                            <div *ngIf="image.thumbnailFlag == 'N'" class="spacimen-label" (click)="openImageLightbox(image.imageId)">
                                                <span class="type-decs" [innerHTML]=displayImageLabelType(image)></span>
                                            </div>
                                        </div>
                                        <div *ngIf="(index >= 9 && index <= 11) && i == 4">
                                            <div *ngIf="image.thumbnailFlag == 'N'" class="spacimen-label" (click)="openImageLightbox(image.imageId)">
                                                <span class="type-decs" [innerHTML]=displayImageLabelType(image)></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <!-- inter -->
                <div class="interpretive-menu">
                    <div class="interpretive-menu-link" aria-multiselectable=true
                        (click)="toggleInterpretiveMenu($event)">Interpretive Menu</div>
                    <div class="interpretive-menu-items-container">
                        <div *ngFor="let menuItem of list.interpretiveMenu | keyvalue" class="interpretive-menu-item">
                            <p class="interpretive-menu-item-name bold">{{menuItem.key}}</p>
                            <ul>
                                <li *ngFor="let note of menuItem.value" class="interpretive-menu-item-note">
                                    <span class="">{{note}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div #lightbox class="image-lightbox">
        <div class="image-lightbox-top-bar">
            <p class="image-lightbox-text-container desktop-only">
                <span class="image-lightbox-image-label">{{selectedLightboxImage.title}}</span>
            </p>
            <div (click)="closeImageLightbox()" class="image-lightbox-exit-button">X</div>
        </div>
        <div class="image-lightbox-image-container">
            <img alt="light box image" src={{selectedLightboxImage.fullsizeS3Url}} class="image-lightbox-image">
        </div>
        <p class="image-lightbox-text-container mobile-only">
            <span class="image-lightbox-image-label">{{selectedLightboxImage.title}}</span>
        </p>
    </div>
</div>
